import { render, staticRenderFns } from "./PopupAlert.vue?vue&type=template&id=395f0cee"
import script from "./PopupAlert.vue?vue&type=script&lang=js"
export * from "./PopupAlert.vue?vue&type=script&lang=js"
import style0 from "./PopupAlert.vue?vue&type=style&index=0&id=395f0cee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports